import React from 'react';

import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Translate } from 'react-localize-redux';

import useContextualStyles from '../contextualStyle';

export type HelpdeskArticleButtonProps = {
  url: string;
  translationId?: TranslationId;
};

export const HelpdeskArticleButton = ({
  url,
  translationId = 'Helpdesk_article',
}: HelpdeskArticleButtonProps) => {
  const classes = useContextualStyles();

  return (
    <div>
      <Link
        underline="none"
        data-fd="Helpdesk_article_link"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Typography className={classes.Button} variant="caption">
          <Translate id={translationId} />
        </Typography>
      </Link>
    </div>
  );
};
